
import { Vue, Component } from 'vue-property-decorator';
import OrganizationPassengerPage from '@/components/Organization/OrganizationPassengerPage.vue';
import Passenger from '../Passenger/models/Passenger';
import AddPassengerToPassengerGroupDialog from '@/components/Organization/AddPassengerToPassengerGroup/AddPassengerToPassengerGroupDialog.vue';
import { IPassengerGroupWithPassengers, IPassengerGroupPassenger } from '@/typings/timit';
import Routes from '@/Routes';
import RemovePassengerFromGroupConfirmationDialog from '../Organization/RemovePassengerFromGroupConfirmationDialog.vue';

@Component({
  components: {
    OrganizationPassengerPage,
    AddPassengerToPassengerGroupDialog,
    RemovePassengerFromGroupConfirmationDialog,
  }
})
export default class PassengerGroupPassengers extends Vue {
  selectedPassenger: IPassengerGroupPassenger | null = null;
  editedPassenger: Passenger | null = null;
  openCreateNewPassengerDialog = false;
  openAddPassengerToPassengerGroupDialog: boolean = false;
  openRemoveConfirmationModal: boolean = false;
  search = '';
  pagination: any = {
    sortBy: 'name',
    descending: true,
    rowsPerPage: 25,
  }

  get passengerGroup(): IPassengerGroupWithPassengers {
    return this.$store.state.organization.selectedPassengerGroup;
  }

  get passengers(): IPassengerGroupPassenger[] {
    if (!this.passengerGroup) {
      return [];
    }

    if (this.showOnlyActivePassengers) {
      return this.passengerGroup.passengerGroupPassengers.filter(p => !p.inactive);
    }

    return this.passengerGroup.passengerGroupPassengers;
  }

  get passengerGroupId() {
    return parseInt(this.$route.params.passengerGroupId, 10) ;
  }

  get headers(): any[] {
    return [
      {
        text: this.$t('passenger.prop.name.label', 'Name'),
        value: 'name',
        sortable: true,
        align: 'left'
      },
      {
        text: this.$t('passenger.prop.destinations.main', 'Main Destination'),
        value: 'destination',
        sortable: true,
        align: 'left'
      },
      {
        text: this.$t('passenger.prop.phoneNumbers.label', 'Phone numbers'),
        value: 'phone',
        sortable: true,
        align: 'left'
      },
      {
        text: this.$t('passenger.prop.tags.label', 'Tags'),
        value: 'groups',
        sortable: true,
        align: 'left'
      },
      {
        text: this.$t('passenger.prop.transportationPermissions.label', 'Transportation permissions'),
        value: 'transportationPermissionCount',
        sortable: true,
        align: 'left'
      },
      {
        text: '',
        sortable: false,
        align: 'right'
      }
    ];
  }

  get showOnlyActivePassengers(): boolean {
    return this.$store.state.passenger.showOnlyActivePassengers;
  }

  set showOnlyActivePassengers(value: boolean) {
    this.$store.commit("passenger/changeShowActivePassengers", value);
  }

  async created() {
    const passengerGroupId = parseInt(this.$route.params.passengerGroupId, 10);
    await this.$store.dispatch('organization/getPassengerGroupWithPassengers', { params: { id: passengerGroupId } });
  }

  createNewPassenger() {
    this.selectedPassenger = null;
    this.editedPassenger = new Passenger(null);
    this.editedPassenger.organizationId = this.$route.params.organizationId;
    this.editedPassenger.transportationPermissionRequired = this.$store.getters['organization/organizationRequirePtpByDefault'](this.editedPassenger.organizationId);
    this.openCreateNewPassengerDialog = true;
  }

  closeCreateNewPassengerDialog() {
    this.openCreateNewPassengerDialog = false;
    this.editedPassenger = null;
  }

  closeAddPassengerToPassengerGroupDialog() {
    this.openAddPassengerToPassengerGroupDialog = false;
  }

  openPassengerDetails(passengerId: number) {
    this.selectedPassenger = this.passengerGroup.passengerGroupPassengers.find(p => p.id === passengerId);
    this.$router.push({
      name: Routes.editPassengerRoute.name,
      params: { passengerId: this.selectedPassenger.id.toString() }
    });
  }

  openRemoveModal(passengerId: number) {
    this.selectedPassenger = this.passengerGroup.passengerGroupPassengers.find(p => p.id === passengerId);
    this.openRemoveConfirmationModal = true;
  }

  closeRemoveModal() {
    this.openRemoveConfirmationModal = false;
    this.selectedPassenger = null;
  }

  removePassengerFromGroup(passenger: IPassengerGroupPassenger) {
    const index = this.passengerGroup.passengerGroupPassengers.indexOf(passenger);
    this.passengerGroup.passengerGroupPassengers.splice(index, 1);
    this.closeRemoveModal();
  }
}
